import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
    },
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  field: {
    marginTop: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  item: {
    marginBottom: theme.spacing(1),
  },
  divider: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  corpoFormulario: {
    margin: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  dados: {
    padding: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  titleCampo: {
    fontSize: '15px',
    marginTop: theme.spacing(2),
  },
  cabecalhoBotao: {
    paddingRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
      '& button': {
        width: '100%',
      },
    },
  },
  linhaTabela: {
    fontSize: '12px',
  },
  tableContainer: {
    paddingBottom: theme.spacing(2),
  },
  addIcon: {
    marginRight: theme.spacing(1),
  },
  fenomenoCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    borderRadius: '12px',
    boxShadow: 'none',
  },
}))
